// @flow
import TextField from "@mui/material/TextField";
import React from 'react';
import ListItemText from "@mui/material/ListItemText";
import ListItem from "@mui/material/ListItem";
import type {Exhibition} from "../../../../../../types/exhibition/types";
import {useTranslation} from "react-i18next";
import {EXHIBITION} from "../../../../../../locales/components/namespaces";
import {Update} from "../../../../../../hooks/exhibitions/useExhibitionAction";
import MenuItem from "@mui/material/MenuItem";
import {CatalogueLanguages} from "../../../../../../helpers/constants";
import Select from "@mui/material/Select";

type Props = {
    id: string,
    exhibition: Exhibition,
    updateExhibition: Function
};

const CatalogueLanguage = (props: Props) => {
    const {t} = useTranslation(EXHIBITION)
    const {id, exhibition, updateExhibition} = props
    
    const onChange = (value) => {
        updateExhibition(id, value, Update.CatalogueLanguage)
    }
    return (
        <ListItem>
            <ListItemText
                primary={t('Catalogue Language')}
                secondary={t('Select if catalogue will be displayed in english, greek or both languages.')}
            />
            <TextField
                select
                name={"badgeTemplateTypeId"}
                value={exhibition.catalogueLanguage}
                onChange={(evt) => onChange(evt.target.value)}
                label={t('Print Size')}
                sx={{minWidth: '220px'}}
                size={"small"}
                variant={'filled'}
                slotProps={{
                    inputLabel: {
                        shrink: true,
                    },
                }}
            >
                <MenuItem
                    value={CatalogueLanguages.ALL}
                >
                    {t('English & Greek')}
                </MenuItem>
                <MenuItem
                    value={CatalogueLanguages.EN}
                >
                    {t('English')}
                </MenuItem>
                <MenuItem
                    value={CatalogueLanguages.EL}
                >
                    {t('Greek')}
                </MenuItem>
            </TextField>
        </ListItem>
    );
};

export default CatalogueLanguage